import { z } from 'zod';
import { documentSchema } from './IDocument';

// #1244 Phase C: Wissensergänzung (KI-Hinweise/Prompts) je Rechtsgeschäftsart-Maßnahme.
export const knowledgeItemSchema = z.object({
  idKnowledgeItem: z.number().default(-1),
  idLegalRequirementTemplate: z.number().nullable().default(null),
  idLegalRequirement: z.number().nullable().default(null),
  TargetAI: z.string().default('all'),
  Title: z.string().default(''),
  Content: z
    .string()
    .nullable()
    .transform(v => v ?? '')
    .default(''),
  activeKnowledgeItem: z
    .union([z.boolean(), z.number().transform(v => Boolean(v))])
    .transform(v => Boolean(v))
    .default(true),
  // PDF-/Dokument-Anhänge (für KI-Bereitstellung / MA-Lektüre).
  DocumentArray: z.array(documentSchema).optional(),
});

export type IKnowledgeItem = z.infer<typeof knowledgeItemSchema>;

// Ziel-KI-Optionen (Anzeige). 'all' = alle KI / allgemeiner Anwendungsbereich.
export const TARGET_AI_OPTIONS: { key: string; label: string }[] = [
  { key: 'all', label: 'Alle KI / allgemein' },
  { key: 'fonio', label: 'Telefon-Bot (IBM)' },
  { key: 'karl', label: 'Karl KI' },
];

export const targetAiLabel = (key?: string): string =>
  TARGET_AI_OPTIONS.find(o => o.key === key)?.label ?? (key || 'Alle KI');
